<style>
	.Nav{
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 .5rem;
		margin-bottom: 1.5rem;
	}
</style>
<nav class="Nav">
	<img src="/img/logo.svg" alt="Logo Sergio Filoth" class="">
</nav>